const Footer = ({ children, className = "", type = "" }) => (
	<footer className={`root-footer ${type ? `root-footer-${type}` : ""} mt-auto d-print-none ${className}`}>
		{children}
	</footer>
);

export default Footer;
